<template>
    <li :class="{ answered:isQuestionAnswered }" @click="quizAcceptAnswer">
        <div
            class="quiz-app__answers__item__checkbox"
            :class="{
                box: multiple,
                checked: isChecked(),
                correct: isChecked() && isCorrect && isQuestionAnswered,
                incorrect: isChecked() && !isCorrect && isQuestionAnswered,
                correctNotChosen: isChecked() && isCorrect && !chosenAnswers.includes(privateModel.id) && multiple && isQuestionAnswered
            }"
        ></div>
        <div class="quiz-app__answers__item__content">
            <div class="quiz-app__answers__item__content__title" v-html="privateModel.title"></div>
            <transition name="fade-in">
                <div
                    class="quiz-app__answers__item__proof"
                    v-show="isQuestionAnswered && isChecked() && privateModel.proof"
                    v-html="privateModel.proof"
                ></div>
            </transition>
        </div>
    </li>
</template>

<script>
import EventBus from '../shared/EventBus'

export default {
    name:'AnswerComponent',
    props: {
        model: { required:true },
        multiple: { default:false },
        chosenAnswers: { default:() => [] },
        revealCorrectAnswers: { default:true },
        isQuestionAnswered: { default:false }
    },
    computed: {
        isCorrect(){
            return this.privateModel.correct == 1
        }
    },
    data: () => ({
        privateModel:null
    }),
    created(){
        this.privateModel = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
        isChecked(){
            let checkedCondition = this.chosenAnswers.includes(this.privateModel.id)
            return !this.revealCorrectAnswers
                ? checkedCondition
                : checkedCondition || (this.isQuestionAnswered && this.privateModel.correct == 1)
        },
        quizAcceptAnswer(){
            EventBus.$emit('choose-answer', this.privateModel.id)
        }
    },
}
</script>

<style lang="scss">
    .fade-in-leave-active,
    .fade-in-enter-active { transition:opacity .5s ease; opacity:1 }
    .fade-in-enter,
    .fade-in-leave-to { opacity:0 }
</style>